//internal-deps
import { WALLET_CODES } from "@swiggy-private/payment-types";

export const WALLET_DISPLAY_NAMES = {
    [WALLET_CODES.paytm]: "Paytm",
    [WALLET_CODES.paytmpostpaid]: "Paytm",
    [WALLET_CODES.phonepe]: "Phonepe",
    [WALLET_CODES.mobikwik]: "Mobikwik",
    [WALLET_CODES.freecharge]: "Freecharge",
    [WALLET_CODES.amazonpay]: "Amazon Pay",
    [WALLET_CODES.simpl]: "Simpl",
    [WALLET_CODES.mmt]: "MMT",
};

export const WALLET_PAYMENT_CODES = {
    [WALLET_CODES.paytm]: "PayTM-SSO",
    [WALLET_CODES.paytmpostpaid]: "PayTM_PostPaid-SSO",
    [WALLET_CODES.phonepe]: "PhonePe",
    [WALLET_CODES.mobikwik]: "Mobikwik-SSO",
    [WALLET_CODES.freecharge]: "Freecharge-SSO",
    [WALLET_CODES.amazonpay]: "AmazonPay",
    [WALLET_CODES.simpl]: "Simpl",
    [WALLET_CODES.mmt]: "mmt",
};

export const LINK_WALLET = `Link {0} Account`;
export const TEXTS = {
    HOLD_ON: "Hold on",
    DELINK_IN_PROGRESS: "We’re trying to delink your account",
};
